<template>
   <div class="row">
      <div class="col">{{label}}:
         <div v-if="hierarchies!=undefined && hierarchies.length>0" id="ddlDiv">
            <div class="dropdown">
               <button type="button" class="btn dropdown-toggle hier-btn" data-toggle="dropdown" v-if="selectedHierarchy != null">
                  {{selectedHierarchy.agentNo}}
               </button>
               <button type="button" class="btn dropdown-toggle hier-btn" data-toggle="dropdown" v-if="selectedHierarchy==null">
                  (Select an Agent#)
               </button>
               <div class="dropdown-menu hier-ctn">
                  <a v-for="(h, indx) in numbers" :key="indx" :value="h" class="dropdown-item hiera" @click.prevent="hierarchyChanged(h)">{{h}}</a>
               </div>
            </div>
         </div>
         <div v-else class="text-danger">(none)</div>
      </div>
   </div>
</template>


<script>
           

export default {
   name: "agentnumddl",
   props: ['hierarchies', 'selectedHierarchy','caption'],
   data() {
      return {
         label: '',
         hasCaption: false,
         numbers: []
      };
   },
   mounted() {
      if (this.caption && this.caption != '') {
         this.hasCaption = true
         this.label = this.caption
      } else {
         this.label = 'Agent Number'
      }
      this.numbers = []
      this.hierarchies.forEach((itm, indx) => {
         if (!this.numbers.includes(itm.agentNo)) {
            this.numbers.push(itm.agentNo)
         }
      });
   },
   methods: {
      hierarchyChanged(itm) {
         this.hierarchies.forEach((hier, indx) => {
            if (itm == hier.agentNo) {
               this.$emit("hier-changed", hier);
            }
         })
      }
   },
};
</script>

<style scoped lang="scss">
.hier-btn {
   background-color: transparent;
   outline: none;
   width: 100%;
   border: 1px solid #ccc;
   border-radius: 3px;
   margin: 0;
}
.hier-ctn {
   width: 100%;
   border: 1px solid #ccc;
   border-radius: 3px;
   margin: 0;
   padding: 0;
}
.hiera {
   line-height:24px;
   border-width: 0 1px 1px 1px;
   border-style: solid;
   border-color: #ccc;
}
#ddlDiv {
   display: inline-block;
}
</style>